import * as React from 'react';
import { ActionsDropdown, ActionsDropdownArrow, ActionsDropdownItem, Box, IconButton } from '@moosend/mooskin';
import { ITableItemAction } from '../../model';
import { PermissionsCheck } from '../PermissionsAndLimitsContext';
import { translateText } from '../../../util/translationHelper';

interface ITableItemActionsProps {
	item?: { [key: string]: any };
	actions: ITableItemAction[];
	onActionClick: (action: string, item: { [key: string]: string } | undefined) => void;
	topAction?: boolean;
	wrapperProps?: { [key: string]: any };
}

export const TableItemActions: React.FC<ITableItemActionsProps> = (props) => {
	const { item, actions, onActionClick, topAction } = props;
	const [dropDown, setDropdown] = React.useState(false);

	const renderDropdown = (actionsItems: { icon?: string; action: string; permission: number }[]) => {
		return (
			<Box position="absolute" top={10} right={topAction ? -4 : -18} pt={20} id="123">
				<ActionsDropdown isOpen={dropDown} boxShadow="md" onClose={() => setDropdown(false)}>
					<ActionsDropdownArrow right={topAction ? 8 : undefined} />
					{actionsItems.map((button, i) => {
						return (
							<PermissionsCheck requiredPermissions={[button.permission]} key={i}>
								<ActionsDropdownItem
									onClick={() => {
										onActionClick(button.action.toLocaleLowerCase(), item ?? undefined);
										setDropdown(false);
									}}
								>
									{translateText(button.action)}
								</ActionsDropdownItem>
							</PermissionsCheck>
						);
					})}
				</ActionsDropdown>
			</Box>
		);
	};

	return (
		<>
			{actions
				? actions.map((button, i) => (
						<Box key={i} {...props.wrapperProps} onClick={(e) => e.stopPropagation()}>
							<IconButton
								noRender={['sm', 'xs']}
								position="relative"
								title={button.action}
								onClick={
									!button.additional?.length
										? () => {
												onActionClick && onActionClick(button.action.toLowerCase(), item);
											}
										: undefined
								}
								onMouseLeave={button.additional?.length ? () => setDropdown(false) : undefined}
								onMouseEnter={button.additional?.length ? () => setDropdown(true) : undefined}
							>
								{button.icon}
								{button.additional?.length ? renderDropdown(button.additional) : null}
							</IconButton>
							<Box noRender={['lg', 'md']}>
								<IconButton
									position="relative"
									title={button.action}
									onClick={() => (onActionClick(button.action.toLowerCase(), item), setDropdown(true))}
								>
									{button.icon}
								</IconButton>
								{button.additional?.length ? renderDropdown(button.additional) : null}
							</Box>
						</Box>
					))
				: null}
		</>
	);
};
